import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChild,
} from '@angular/core';
import {
  NavController,
  PopoverController,
  ToastController,
  AlertController,
  Platform,
} from 'ionic-angular';
import * as debug from 'debug';
import * as _ from 'lodash';
import * as $ from 'jquery';
import { SocialSharingProvider } from '../../providers/social-sharing/social-sharing';
import { CrudApiProvider } from '../../providers/crud-api/crud-api';
import { ToolsProvider } from '../../providers/tools/tools';
import { UserProvider } from '../../providers/user/user';
import { PlaceServiceProvider } from '../../providers/trip-service/place-service';
import { UiToolsProvider } from '../../providers/ui-tools/ui-tools';
import { ImageViewerProvider } from '../../providers/image-viewer/image-viewer';
import { SettingsProvider } from '../../providers/settings/settings';
import { ScreenOrientation } from '@ionic-native/screen-orientation';
import { ConfigProvider } from '../../providers/config/config';
import { ContentToolsProvider } from '../../providers/content-tools/content-tools';
import { NewsBrowserProvider } from '../../providers/news-browser/news-browser';

declare let CmKit: any;

const blockImpressionAction = {},
  sharesInThisLoad = {};

@Component({
  selector: 'post',
  templateUrl: 'post.html',
})
export class PostComponent {
  log = debug('app:PostComponent');
  moderator = false;

  @ViewChild('postComponent') postComponent;
  @ViewChild('scrollWatchDirective') scrollWatchDirective;

  // Inputs --------

  @Input()
  post: any;

  @Input()
  temporarilyBlockOpen: any = false;

  @Input()
  canNavToSourceProfile: any = true;

  @Input()
  fullPost = false;

  @Input()
  searchedPost = false;

  // Events ---------------

  @Output()
  scrollToEmitter = new EventEmitter();
  @Output() onHidePost = new EventEmitter();
  @Output() onBlockUser = new EventEmitter();
  @Output() onPostAction = new EventEmitter();

  // Internal stuff

  preventPropagation = false;
  showWhiteBox = true;
  isDeleted = false;
  userEngagements: any = {};
  videoElement;
  videoAutoPlayTimeout;
  pauseUnMute = false;
  navToComments = false;
  liking = false;
  comment: any = {};
  parentPostId;
  isInViewPort;

  // Flagged Content Variables

  reportedComment: any = {};
  commentReportCount = 0;
  postReports = 0;
  showThread = false;
  moderatorHidden = false;
  visibilitySetting = 'SHOW';
  subs = [];
  myPost = false;
  noPostFound = false;
  impression = false;
  actionSheetButtons = [];
  boostCost: number = 100;
  karmaMile: number = 0;
  customComponent;
  isCustomComponent = false;
  views: any[] = [];

  constructor(
    public navCtrl: NavController,
    private socialSharingService: SocialSharingProvider,
    public crudApi: CrudApiProvider,
    public tools: ToolsProvider,
    public user: UserProvider,
    public alertCtrl: AlertController,
    public placesService: PlaceServiceProvider,
    public uiTools: UiToolsProvider,
    public imgViewer: ImageViewerProvider,
    public settingsProvider: SettingsProvider,
    public screenOrientation: ScreenOrientation,
    public config: ConfigProvider,
    public contentTools: ContentToolsProvider,
    public newsBrowser: NewsBrowserProvider
  ) {}

  ngOnInit() {
    let p = this.post;

    if (!p) {
      this.noPostFound = true;
      return;
    }

    if (_.get(this.post, 'options.componentType')) {
      this.isCustomComponent = true;
      // this.customComponent = this.post.options.componentType;

      const alternates = _.get(this.post, 'options.alternates');
      if (_.size(alternates)) {
        // console.log('slot before an alternate', this.post.options.componentType, alternates);
        const totalWeight = alternates.reduce(
          (sum, alternate) => sum + alternate.weight,
          0
        );
        const randomNumber = Math.floor(Math.random() * totalWeight) + 1;

        let cumulativeWeight = 0;
        let selectedAlternate = null;
        for (const alternate of alternates) {
          cumulativeWeight += alternate.weight;
          if (randomNumber <= cumulativeWeight) {
            selectedAlternate = alternate;
            break;
          }
        }
        this.post.options = selectedAlternate.slot.options;
        // console.log('picked an alternate', this.post.options.componentType);
      }
    }

    this.visibilitySetting = this.contentTools.getVisibilitySettingForContent(
      this.post
    );

    this.moderator = this.user.isModerator();

    const engagements = _.get(this.post, 'userEngagements');
    this.userEngagements = this.tools.userEngagementsOnPost(engagements);

    this.subs.push(
      this.tools.on(`post-updated-${this.post._id}`, (component, post) => {
        if (component !== this) {
          _.extend(this.post, post);
          this.triggerPostChange(true);
        }
      })
    );
    this.subs.push(
      this.tools.on(`post-deleted-${this.post._id}`, p => {
        if (this.post._id === p._id) {
          this.showWhiteBox = true;
          this.isDeleted = true;
        }
      })
    );
    this.subs.push(
      this.tools.on(`post-comment-${this.post._id}`, engagement => {
        if (this.post._id === engagement.post) {
          this.triggerPostChange(true);
        }
      })
    );

    this.subs.push(
      this.tools.on(`post-show-sensitive-clicked-${this.post._id}`, () => {
        this.contentTools.whiteListSensitive(this.post);
        _.set(this.post, 'states.isSensitive', false);
        this.postComponent.update();
      })
    );

    if (_.get(p.user, 'username') === this.user.get('username')) {
      this.myPost = true;
    }

    if (this.fullPost) {
      this.tools.postEngagement(_.get(this, 'post._id'));
      this.showWhiteBox = false;
      setTimeout(() => {
        this.trackAnalytics();
      }, 10);
    }

    this.karmaMile = _.get(this.user.info, 'stats.events.karmaMile') || 0;
    this.boostCost = Math.abs(this.config.get('karmaMiles').POST_BOOST) || 100;
  }

  // Post Openings ---------------------

  blockOpen() {
    const id = (this.temporarilyBlockOpen = _.get(this.post, '_id'));
    setTimeout(() => {
      // make sure blockopen wasn't called again
      if (this.temporarilyBlockOpen === id) {
        this.temporarilyBlockOpen = false;
      }
    }, 500);
    return id;
  }

  whereAmI(location) {
    this.log('scrolling | whereAmI - location', location);
    this.isInViewPort = location;
  }

  openLiveChatPage() {
    this.tools.emit('changeActiveTab', { id: 'liveChat', label: 'LiveChat' });
  }

  clickedHashTag(event) {
    let hashTagEvent = _.replace(event.detail, 'HASH_', '');

    this.log('clickedHashTag | tagEvent filter', hashTagEvent);
    this.tools.emit('forceMenusShow');
    this.tools.emit('tag-click', hashTagEvent);
    this.tools.logAnalyticsEvent('trackCustom', 'post-hashtag-click', {
      hashtag: hashTagEvent,
    });
  }

  showSensitiveClicked() {
    this.tools.emit(`post-show-sensitive-clicked-${this.post._id}`);
    this.contentTools.whiteListSensitive(this.post);
  }

  openLink(link) {
    this.log('openLink | post', this.post);
    if (_.get(this, 'post.postType') === 'AD') {
      this.logAnalyticsEvent('trackCustom', 'ad-click', {
        post: _.get(this, 'post._id'),
      });
    } else {
      this.logAnalyticsEvent('trackCustom', 'link-click', {
        post: _.get(this, 'post._id'),
      });
    }
    this.tools.postEngagement(_.get(this, 'post._id'));

    // removed amp article links - 09-20-24
    // if (
    //   _.get(this, 'post.postType') === 'LINK' ||
    //   _.get(this, 'post.postType') === 'ARTICLE'
    // ) {
    //   const ampUrl =
    //     _.get(this, 'post.postType') === 'LINK'
    //       ? _.get(this, 'post.linkInformation.ampUrl')
    //       : _.get(this, 'post.articleInformation.ampUrl');
    //   link = ampUrl ? ampUrl : link;
    //   this.log('openLink | link: ', link);
    // }

    const match = link && link.match(/\/feed\/individual-job\/(.*)/);

    if (match) {
      let jobId = match[1];
      this.tools.openExternalUrl(
        `https://landing.cdllife.com/job/${jobId}`,
        '_blank',
        {
          clid: _.get(this, 'post.clid'),
          rt: 'mobileApp',
        }
      );
      return;
    }

    if (link) {
      this.onPostAction.emit('link-click');
      // if (/cdllife.com\/2020/i.test(link) && !/\?amp/.test(link)) {
      //   if (/\?/.test(link)) {
      //     link += '&amp';
      //   } else {
      //     link += '?amp';
      //   }
      // }

      this.openLinkCheckNewsBrowser(link);
    }
  }

  async openLinkCheckNewsBrowser(url: string) {
    // ^https://([a-z0-9-]+\.)?cdllife\.com$ // any sub
    // ^https://(www\.)?cdllife\.com$ // only root

    const regex = /^https?:\/\/(www\.)?cdllife\.com\/20.*?$/;

    if (regex.test(url)) {
      // alert('getting news artile' + url);
      const mobileArticle = await this.tools.getNewsArticleFromUrl(url);

      if (mobileArticle) {
        this.log('openLink | cdllife article', mobileArticle);
        return this.newsBrowser.openArticle(mobileArticle);
      } else {
        this.log('openLink | external link', url);
        this.tools.openExternalUrl(url, '_blank', {});
      }
    } else {
      this.log('openLink | outside url', url);
      this.tools.openExternalUrl(url, '_blank', {});
    }
  }

  imageClick(evt) {
    const src = _.get(evt, 'image.imageUrl');

    this.logAnalyticsEvent('trackCustom', 'post-open-photo', {
      post: _.get(this, 'post._id'),
    });

    if (src) {
      this.imgViewer.open(src, evt);
    }
  }

  openPlace(id) {
    this.crudApi.get('/api/places/' + id).then(place => {
      if (place && place.data) {
        this.placesService.openStopDetailPageForPlace(place.data);
      } else {
        this.tools.defaultAlert('The place no longer exists.');
      }
    });
  }

  openPost(e?) {
    if (!this.fullPost && !this.temporarilyBlockOpen) {
      if (this.navToComments) {
        this.logAnalyticsEvent('trackCustom', 'post-nav-to-comments', {
          post: _.get(this, 'post._id'),
        });
      }

      if (this.post.postType === 'JOB') {
        if (this.navToComments) {
          this.navCtrl.push('CommunityPostsPage', {
            post: this.post,
            post_id: this.post._id,
            engagement: e,
            navToComments: this.navToComments,
          });
        } else {
          let jobId = _.get(this.post.jobInformation.job, '_id');
          this.tools.openExternalUrl(
            `https://landing.cdllife.com/job/${jobId}`,
            '_blank',
            {
              clid: _.get(this, 'post.clid'),
              rt: 'mobileApp',
            }
          );
        }
      } else {
        this.navCtrl.push('CommunityPostsPage', {
          post: this.post,
          post_id: this.post._id,
          engagement: e,
          navToComments: this.navToComments,
        });
      }

      // prevent registering impressions twice
      blockImpressionAction[this.post._id] = true;
      setTimeout(() => {
        delete blockImpressionAction[this.post._id];
      }, 500);

      this.onPostAction.emit('open');
    }

    setTimeout(() => {
      this.navToComments = false;
    }, 1000);
  }

  openThread(event) {
    let viewsId;

    this.views = this.navCtrl.getViews();

    if (this.views.length > 0) {
      this.views = this.views[this.views.length - 1];

      viewsId = _.get(this.views, 'id');
    }

    this.log('openThread | post thread', this.post);

    if (viewsId === 'CommunityPostsPage') {
      this.log('openThread | view thread');
    } else {
      this.navCtrl.push('CommunityPostsPage', {
        // post: this.post.post,
        post_id: this.post.post,
        engagement: this.post._id,
        navToComments: true,
        thread: true,
      });
    }
  }

  navToUsersProfile() {
    if (_.includes(['JOB', 'AD'], this.post.postType)) {
      if (!this.fullPost) {
        this.temporarilyBlockOpen = false;
        this.openPost('fake');
      }
    } else if (_.get(this.post, 'user._id') === this.user.get('_id')) {
      this.navCtrl.push('UserProfilePage', {
        user: this.user,
        user_id: this.user.info._id,
      });
    } else if (_.get(this.post, 'postType') === 'ARTICLE') {
      this.navToNewsSourceProfile();
    } else {
      this.navCtrl.push('UserProfilePage', {
        user: _.get(this.post, 'user'),
        user_id: _.get(this.post, 'user._id'),
      });
    }
  }

  taggedUser(event) {
    let taggedUserId = event.detail.id;

    if (taggedUserId) {
      this.navCtrl.push('UserProfilePage', {
        user_id: taggedUserId,
      });
      this.tools.logAnalyticsEvent('trackCustom', 'post-tagged-users-click', {
        userId: taggedUserId,
      });
    }
  }

  navToNewsSourceProfile() {
    if (!this.canNavToSourceProfile) {
      return;
    }

    const newsSource = _.get(this, 'post.source');
    this.log('navToNewsSourceProfile | newsSource', newsSource);
    return this.navCtrl.push('NewsSourceProfilePage', {
      source: newsSource,
      user: _.get(this, 'post.user._id'),
    });
  }

  scrollToComments() {
    if (this.fullPost) return;
    this.navToComments = true;
    this.scrollToEmitter.emit(0);
  }

  // Moderation/blocking/etc Stuff -----------

  private flaggedContentHidePost() {
    this.log(
      'flaggedContentHidePost | reported comment',
      _.get(this.reportedComment, 'isBanned')
    );
    if (_.get(this.reportedComment, 'isBanned')) {
      this.reportedComment.states.isBanned = true;
      this.crudApi
        .put(`/api/engagements/${this.reportedComment._id}`, {
          states: { isBanned: true },
        })
        .then(response => {
          this.presentToast('Content has been reinstated');
        })
        .catch(e => {
          this.log('flaggedContentHidePost | error', e);
        });
    } else {
      this.log('flaggedContentHidePost | reported post', _.get(this, 'post'));
      this.post.states.isBanned = true;
      this.crudApi
        .put(`/api/posts/${this.post._id}`, {
          states: { isBanned: true },
        })
        .then(response => {
          this.moderatorHidden = true;
          this.presentToast('Content has been hidden');
        })
        .catch(e => {
          this.log('flaggedContentHidePost | error', e);
        });
    }
  }

  private blockUser() {
    let postCreator = this.post.user.firstName + ' ' + this.post.user.lastName;
    let alert = this.alertCtrl.create({
      title: 'Are you sure you want to block ' + postCreator + ' ?',
      subTitle: this.tools.getBlockUserWarning(
        _.get(this, 'post.user.username')
      ),
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'alert-button-cancel',
          handler: data => {
            this.log('blockUser | Cancel clicked');
          },
        },
        {
          text: 'Yes',
          cssClass: 'alert-button-confirmatory',
          handler: data => {
            this.log('blockUser | post: ', this.post);
            const postUser = _.get(this, 'post.user._id');
            this.onBlockUser.emit();
            this.crudApi
              .put(`/api/users/${this.user.get('_id')}`, {
                blockUser: postUser,
              })
              .then(res => {
                this.log('blockUser | blocked User response: ', res);
                this.presentToast('The user has been blocked');

                this.user.info.blockedUsers =
                  _.get(res, 'data.blockedUsers') || [];
                this.user.emit('hideShowContent');
              })
              .catch(e => {
                this.presentToast('Could not block user');
                this.log('blockUser | blocked user failed: ', e);
              });
          },
        },
      ],
      cssClass: 'alert-title',
    });

    alert.present();
  }

  private async reportContent() {
    const res = await this.contentTools.selectCategory(
      `What type of content is this?`
    );

    if (!res) return;

    this.userEngagements.reported = true;

    try {
      await this.crudApi
        .post('/api/engagements', {
          post: this.post._id,
          engagementType: 'REPORT',
          reportInformation: {
            category: res.key,
          },
        })
        .then(response => {
          this.post.userEngagements.push(response.data);
        });
    } catch (e) {
      // dont care
    }

    CmKit.ActionSheet({
      props: {
        templates: {
          title: `
                <div style="text-align:center">
                  <div cm-font="Title / 20 Medium"
                       class="cm-Margin--bottom"
                       cm-color="Neutral / Mine Shaft">
                       Thanks for Looking Out
                       </div>
                  <div cm-font="Body 16 / Regular"
                       class="cm-Margin--bottom"
                       cm-color="Neutral / Mine Shaft">
                       If you’d like, you can control what type of content shows up in your feed by updating some of your account settings.
                  </div>
                </div>
                `,
          button: button => {
            return `
                  <button class="cm-Button cm-Button--1 cm-Width-1-1"
                          cm-color="Primary / CDLLife Blue">
                  ${button.text}
                  </button>
                  `;
          },
          cancel: `
                <div style="text-align:center"
                      cm-font="Button / 14 Regular"
                      class="cm-Margin--bottom"
                      cm-color="Neutral / Manatee">
                  Dismiss
                </div>
                `,
        },
        buttons: [
          {
            text: 'Update Feed Settings',
            handler: () => {
              this.navCtrl.push('FeedContentSettingsPage');
            },
          },
        ],
      },
    });
  }

  // Engaging with post ------------

  videoPlaying(e) {
    this.log('videoPlaying | video playing', e);
    this.scrollWatchDirective.start();
    this.videoElement = e && e.video;
    this.tools.videoPlaying(e && e.video);
    if (window['cordova']) {
      this.screenOrientation.unlock();
    }
    this.logAnalyticsEvent('trackCustom', 'post-play-video', {
      post: _.get(this, 'post._id'),
    });

    this.tools.postEngagement(_.get(this, 'post._id'));

    const muted = _.get(e, 'video.muted');
    if (muted === true && !this.pauseUnMute) {
      e.video.muted = false;
    }
  }

  videoPaused(e) {
    if (window['cordova']) {
      this.screenOrientation.lock(this.screenOrientation.ORIENTATIONS.PORTRAIT);
    }
    this.tools.pauseVideo(e && e.video);
  }

  videoReady(e) {
    this.videoElement = e && e.video;
  }

  checkActivatedUser() {
    if (_.size(this.tools.getPostImpressions()) >= 3) {
      this.user.setActivatedUserStatus();
    }
  }

  trackAnalytics() {
    let full = this.fullPost ? '-full' : '';
    let post = _.get(this, 'post._id');
    let user = _.get(this, 'post.user._id');
    let post_text =
      _.get(this, 'post.adInformation.text') ||
      _.get(this, 'post.articleInformation.description') ||
      _.get(this, 'post.photoInformation.caption') ||
      _.get(this, 'post.videoInformation.caption') ||
      _.get(this, 'post.linkInformation.caption') ||
      _.get(this, 'post.link_data.review.review') ||
      _.get(this, 'post.messageInformation.message');
    let meta = {
      post,
      post_user: user,
      post_text: _.words(post_text).slice(0, 5).join(' '),
    };
    let impressionType =
      _.get(this, 'post.adInformation.adSource') === 'DIRECT_AD' &&
      _.get(this, 'post.postType') === 'AD'
        ? 'ad-impression'
        : _.get(this, 'post.postType') === 'JOB'
        ? 'job-ad-impression'
        : _.get(this, 'post.postType') === 'ARTICLE'
        ? 'article-impression'
        : 'post-impression';

    if (!this.impression) {
      if (!blockImpressionAction[this.post._id]) {
        this.onPostAction.emit('impression');
      }

      if (impressionType) {
        this.log(
          'trackAnalytics | impressionType',
          impressionType + full,
          meta
        );
        this.logAnalyticsEvent('trackCustom', impressionType + full, meta);
        // if (_.get(this, 'post.postType') === 'ARTICLE') {
        //   this.logAnalyticsEvent('trackCustom', 'post-impression' + full, meta);
        // }
        if (this.searchedPost) {
          this.logAnalyticsEvent(
            'trackCustom',
            'post-impression-searched',
            meta
          );
        }
      }

      this.tools.postImpression(_.get(this, 'post._id'));
    }
    this.impression = true;
  }

  async viewMoreYoutube(event?) {
    this.navCtrl.push('YoutubeFeedPage');
  }

  async presentEllipsisActionSheet(event?) {
    let post;

    if (event.detail) {
      post = event.detail.post;
      await this.contentTools.actionSheet(post, 'engagements', {
        navCtrl: this.navCtrl,
        userEngagements: {},

        // Fns ----
        onURM: () => {
          this.urmSendApproved(post);
        },
        onPin: () => {
          this.togglePin(post);
        },
        onEdit: () => {
          this.editPost(post);
        },
        onCategorize: dimensions => {
          _.set(post, 'dimensions', dimensions);
        },
        onReport: () => {
          console.warn('report');
          this.onHidePost.emit();
          this.tools.emit('hideShowContent');
          this.user.emit('hideShowContent');
        },
        onDelete: () => {
          // this.deletePost();
          this.presentToast('Post has been deleted. Thanks!');
          this.tools.emit('userPostDelete');
          this.tools.emit(`post-deleted-${post._id}`, post);
          this.moderatorHidden = true;
        },
      });
    } else {
      post = this.post;
      await this.contentTools.actionSheet(post, 'posts', {
        navCtrl: this.navCtrl,
        userEngagements: {},

        // Fns ----
        onURM: () => {
          this.urmSendApproved(post);
        },
        onPin: () => {
          this.togglePin(post);
        },
        onEdit: () => {
          this.editPost(post);
        },
        onCategorize: dimensions => {
          _.set(post, 'dimensions', dimensions);
        },
        onReport: () => {
          console.warn('report');
          this.onHidePost.emit();
          this.tools.emit('hideShowContent');
          this.user.emit('hideShowContent');
        },
        onDelete: () => {
          // this.deletePost();
          this.presentToast('Post has been deleted. Thanks!');
          this.tools.emit('userPostDelete');
          this.tools.emit(`post-deleted-${post._id}`, post);
          this.moderatorHidden = true;
        },
      });
    }

    this.triggerPostChange();
  }

  private logAnalyticsEvent(title, subtitle, metadata?) {
    const clid = _.get(this.post, 'clid');

    if (clid) {
      if (!metadata) {
        metadata = {};
      }

      _.set(metadata, 'clid', clid);
    }

    this.tools.logAnalyticsEvent(title, subtitle, metadata);
  }

  private editPost(post) {
    this.log('editPost | will edit post', post);
    this.navCtrl.push('CreatePostPage', {
      post: post,
      editingPost: true,
    });
  }

  presentShareActionSheet() {
    this.socialSharingService.sharePost(this.post).then(d => {
      if (!this.socialSharingService.shouldIncrementSharing(d)) {
        return;
      }

      if (sharesInThisLoad[this.post._id]) {
        return;
      }

      sharesInThisLoad[this.post._id] = true;

      this.logAnalyticsEvent('trackCustom', 'share-post', {
        post: _.get(this, 'post._id'),
      });

      this.crudApi
        .post('/api/engagements', {
          post: this.post._id,
          engagementType: 'SHARE',
          shareInformation: { value: 1 },
        })
        .then(response => {
          this.post.userEngagements.push(response.data);
          this.post.stats.shares += 1;
          setTimeout(() => {
            this.tools.logEventAndFlush('share');
          }, 5000);
        })
        .catch(e => {
          this.log('presentShareActionSheet | an error occured', e);
        });
    });
  }

  likePost(event?) {
    console.warn('event here', event);
    let query = {};
    let thread = false;

    if (event.detail) {
      thread = _.get(event.detail, 'thread' || false);
    }

    this.tools.postEngagement(_.get(this, 'post._id'));

    event.stopPropagation();
    if (!this.user.userPermission('like')) {
      return this.tools.loginBlock('You must be logged in to like a post.');
    }

    if (this.liking) return;
    this.liking = true;

    if (this.userEngagements.liked) {
      this.userEngagements.liked = false;
      this.deleteEngagement('LIKE', 1, this.post);

      this.triggerPostChange();
      this.liking = false;
      return;
    } else {
      this.logAnalyticsEvent('trackCustom', 'like-post', {
        post: _.get(this, 'post._id'),
      });

      this.post.stats.likes += 1;

      this.tools.requestReview();

      this.post.userEngagements.push({
        engagementType: 'LIKE',
        likeInformation: { value: 1 },
        _id: Math.random(),
      });
      this.userEngagements.liked = true;
      this.triggerPostChange();

      if (thread) {
        query = {
          post: _.get(event.detail.post, 'post'),
          parentComment: _.get(event.detail.post, '_id'),
          engagementType: 'LIKE',
          likeInformation: { value: 1 },
        };
      } else {
        query = {
          post: this.post._id,
          engagementType: 'LIKE',
          likeInformation: { value: 1 },
        };
      }

      this.crudApi
        .post('/api/engagements', query)
        .then(response => {
          this.log('likePost | posted Like', response);

          this.post.userEngagements.push(response.data);
          this.liking = false;

          this.tools.logEventAndFlush('upVote');
        })
        .catch(e => {
          this.log('likePost | an error occured', e);
          this.userEngagements.liked = false;
          this.post.stats.likes--;
          this.liking = false;
        });
    }
  }

  likeThread(event?) {
    let query = {};
    event.stopPropagation();

    this.tools.requestReview();

    query = {
      post: _.get(event.detail.thread, 'post'),
      parentComment: _.get(event.detail.thread, '_id'),
      engagementType: 'LIKE',
      likeInformation: { value: 1 },
    };
    this.crudApi
      .post('/api/engagements', query)
      .then(response => {
        this.log('likeThread | posted Like', response);
        this.tools.logEventAndFlush('upVote');
      })
      .catch(e => {
        this.log('likeThread | an error occured', e);
      });
  }

  private deleteEngagement(engagementType, likeValue?, post?) {
    this.log('deleteEngagement');
    if (engagementType === 'LIKE') {
      post.userEngagements = _.filter(post.userEngagements, e => {
        return !(e.engagementType === 'LIKE' && _.isNumber(_.get(e, '_id')));
      });
    }
    const engagement = _.find(post.userEngagements, d => {
      if (engagementType === 'LIKE') {
        this.log('deleteEngagement | like/unlike', d);
        return (
          d.engagementType === engagementType &&
          likeValue === _.get(d, 'likeInformation.value')
        );
      }
      return d.engagementType === engagementType;
    });

    if (!engagement) {
      this.log('deleteEngagement | engagement not found');
      return Promise.resolve();
    }
    this.log('deleteEngagement | engagement found', engagement._id);
    this.log('deleteEngagement | local engagements b4', post.userEngagements);
    this.log('deleteEngagement | deleteEngagement found');
    // Remove from user engagement list locally
    post.userEngagements = _.filter(post.userEngagements, e => {
      return e._id !== engagement._id;
    });

    this.log(
      'deleteEngagement | local engagements after',
      post.userEngagements
    );

    // update stats
    if (engagementType === 'LIKE' && likeValue === 1) {
      post.stats.likes -= 1;
    } else if (engagementType === 'LIKE' && likeValue === -1) {
      post.stats.dislikes -= 1;
    }

    // update booleans
    this.log('deleteEngagement | local user engagemnts', this.userEngagements);
    this.userEngagements = this.tools.userEngagementsOnPost(
      post.userEngagements
    );
    this.log(
      'deleteEngagement | local userengagemnts after',
      this.userEngagements
    );
    this.triggerPostChange();

    return this.crudApi.delete(`/api/engagements/${engagement._id}`).then(
      response => {
        this.log('deleteEngagement | Delete Response: ', response);
      },
      e => {
        // this.tools.defaultAlert('An error occured.');
      }
    );
  }

  pollVote(choice) {
    if (!this.user.userPermission('poll')) {
      return this.tools.loginBlock('You must be logged in.');
    }

    this.log('pollVote | handling poll vote');

    const choiceId = _.get(choice, '_id') || null;

    if (!choiceId) {
      return alert('something went wrong');
    }

    if (!_.get(this.post, 'userEngagements')) {
      _.set(this.post, 'userEngagements', []);
    }

    this.post.userEngagements.push({
      engagementType: 'POLL_VOTE',
      _id: Math.random(),
    });

    try {
      this.post.pollInformation.totalVotes =
        (this.post.pollInformation.totalVotes || 0) + 1;
    } catch (e) {}
    try {
      choice.votes = (choice.votes || 0) + 1;
    } catch (e) {}

    this.triggerPostChange();

    this.crudApi
      .post('/api/engagements', {
        post: this.post._id,
        engagementType: 'POLL_VOTE',
        voteInformation: { choiceId: choiceId },
      })
      .then(response => {
        this.log('pollVote | posted vote submitted', response);
        this.tools.logEventAndFlush('pollVote');
        this.tools.logAnalyticsEvent('trackCustom', 'pollVote', {
          post_id: this.post._id,
        });
        this.tools.emit(`pollVote-${this.post._id}`, choiceId);
        try {
          this.post.userEngagements.push(response.data);
        } catch (e) {}
      })
      .catch(e => {
        this.log('pollVote | an error occured', e);
      });
  }

  showBoostDetails() {
    let content = `
      <style>
        .pill {
          display: flex;
          justify-content: flex-start;
          width: 100%;
          margin: -10px 0 25px -10px;
        }
        .content {
          display: flex;
          align-items: center;
          gap: 8px;
        }
        .fa-user-circle {
          color: #2e5ff6;
        }
        .pillText {
          font-weight: 500;
          font-size: 13px;
          letter-spacing: 0.01em;
          color: #2E5FF6;
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          padding: 2.5px 4px;
          gap: 10px;
          background: rgba(46, 95, 246, 0.05);
          border-radius: 4px;
        }
        .contentContainer {
          display: flex;
          flex-direction: column;
          gap: 8px;
          text-align: center;
          height: 65vh;
        }
        .boost--post-header {
          font-weight: 600;
          font-size: 20px;
          text-align: center;
          background: linear-gradient(256.71deg, #2E5FF6 0%, #7551E4 99.25%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          text-fill-color: transparent;
        }
        .flex {
          display: flex;
          flex-grow: 1;
        }
        .infoContainer {
          display: flex;
          justify-content: space-around;
          align-items: center;
          align-self: center;
        }
        .info {
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 18px 12px;
          gap: 8px;
          font-weight: 500;
          font-size: 14px;
          background: linear-gradient(256.71deg, #2E5FF6 0%, #7551E4 99.25%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          color: transparent;
        }
        .title {
          display: flex;
          align-items: center;
          line-height: 1em;
          gap: 8px;
        }
        .karma {
          color: #989aa2;
          -webkit-text-fill-color: #989aa2;
          font-weight: 300;
          font-size: 14px;
        }
        .value {
          font-size: 23px;
        }
        .cost {
          color: #2E5FF6;
          font-weight: 500;
        }
        hr {
          background: #E1E1E1;
          width: 100%;
        }
      </style>
      <div class="pill">
        <div class="content">
          <i class="far fa-user-circle"></i>
          <span class="pillText">
            ${this.karmaMile} Karma Miles
          </span>
        </div>
      </div>
      <div class="contentContainer">
        <div class="boost--post-header">Boosted Post</div>
        <div class="description">
          ${_.get(this.post, 'user.userNamePretty')} boosted their post!
        </div>
        <div class="description">
          Spend ${this.boostCost} karma miles to boost any of your own posts
        </div>
        <hr />
        <div class="infoContainer">
          <div class="info">
            <div class="title">
              <svg width="14" height="18" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.64062 16.5469C0.421875 17.7188 -0.140625 20.7656 0 24C3.23438 24.1406 6.28125 23.5781 7.45312 22.3594C9.375 20.4844 9.46875 17.9531 7.78125 16.2188C6.04688 14.5312 3.51562 14.625 1.64062 16.5469ZM5.48438 20.4844C5.0625 20.8594 4.07812 21.0469 3 21C2.95312 19.9219 3.14062 18.9375 3.51562 18.5156C4.17188 17.9062 5.01562 17.8594 5.57812 18.4219C6.14062 18.9844 6.09375 19.8281 5.48438 20.4844ZM23.6719 0.9375C23.5781 0.65625 23.3438 0.421875 23.0625 0.328125C21.5625 0 20.3906 0 19.2188 0C14.3906 0 11.4844 2.625 9.32812 6H4.40625C3.65625 6 2.76562 6.5625 2.4375 7.26562L0.09375 11.9062C0.046875 12.0469 0 12.2344 0 12.375C0 13.0312 0.46875 13.5 1.125 13.5H6C8.48438 13.5 10.5 15.5625 10.5 18V22.875C10.5 23.5312 10.9688 24 11.625 24C11.7656 24 11.9531 23.9531 12.0938 23.9062L16.7344 21.6094C17.4375 21.2344 17.9531 20.3438 17.9531 19.5938V14.6719C21.375 12.5156 23.9531 9.60938 23.9531 4.78125C24 3.60938 24 2.4375 23.6719 0.9375ZM16.7812 12.7969C15.5625 13.5469 16.4062 13.125 12.0938 15.2344C11.4375 13.7344 10.2656 12.5625 8.76562 11.9062C10.875 7.59375 10.4531 8.4375 11.2031 7.21875C13.4062 3.75 15.7969 2.25 19.2188 2.25C20.0625 2.25 20.7656 2.25 21.6094 2.39062C21.75 3.23438 21.75 3.98438 21.7031 4.78125C21.7031 8.15625 20.25 10.5938 16.7812 12.7969ZM17.25 4.875C16.1719 4.92188 15.375 5.71875 15.375 6.75C15.375 7.82812 16.1719 8.625 17.25 8.625C18.2812 8.625 19.125 7.82812 19.125 6.75C19.125 5.71875 18.2812 4.92188 17.25 4.875Z" fill="url(#paint0_linear_5016_98716)"/>
                <defs>
                <linearGradient id="paint0_linear_5016_98716" x1="24" y1="-2.99999" x2="-4.64472" y2="2.41077" gradientUnits="userSpaceOnUse">
                <stop stop-color="#2E5FF6"/>
                <stop offset="0.99253" stop-color="#7551E4"/>
                </linearGradient>
                </defs>
              </svg>
              <span>
                Boost Post
              </span>
            </div>
            <div class="value">${this.boostCost}</div>
            <div class="karma">Karma Miles</div>
          </div>
        </div>
        <div class="flex"></div>
      <div>
    `;

    CmKit.ActionSheet({
      props: {
        templates: {
          title: content,
          button: button => {
            return `
                    <button class="cm-Button cm-Button--1 cm-Width-1-1"
                            cm-color="Primary / CDLLife Blue">
                    ${button.text}
                    </button>
                    `;
          },
          cancel: `
              <div style="text-align:center"
                    cm-font="Button / 14 Regular"
                    class="cm-Margin--bottom"
                    cm-color="Neutral / Manatee">
                No Thanks
              </div>
            `,
        },
        buttons: [
          {
            text: 'Boost one of your posts',
            handler: () => {
              this.navCtrl.push('UserPostsPage', {
                user: this.user.get(),
                user_id: this.user.info._id,
              });
            },
          },
        ],
      },
    });
  }

  // visibility ---------

  scrollClose() {
    this.log('scrolling | close ' + _.get(this, 'post._id'));
    this.showWhiteBox = false;
  }

  firstScrollEnter() {
    if (_.get(this, 'post.postType') === 'VIDEO' && this.videoElement) {
      if (this.fullPost) return;
      const autoplaySetting = this.settingsProvider.get('autoplayVideos');
      if (autoplaySetting === false) {
        // don't do nuttin
        return;
      }

      this.videoAutoPlayTimeout = setTimeout(() => {
        const self = this;
        if (autoplaySetting === true) {
          runAutoPlay();
        } else {
          CmKit.ActionSheet({
            props: {
              templates: {
                title: `
                <div style="text-align:center">
                  <div cm-font="Title / 20 Medium"
                       class="cm-Margin--bottom"
                       cm-color="Neutral / Mine Shaft">Autoplay Videos?</div>
                  <div cm-font="Body 16 / Regular"
                       class="cm-Margin--bottom"
                       cm-color="Neutral / Mine Shaft">
                  If you’d like, we can autoplay videos when
                  you scroll to them in the feed.
                  You can change this at any time in your app settings.
                  </div>
                </div>
                `,
                button: button => {
                  return `
                  <button class="cm-Button cm-Button--1 cm-Width-1-1"
                          cm-color="Primary / CDLLife Blue">
                  ${button.text}
                  </button>
                  `;
                },
                cancel: `
                <div style="text-align:center"
                      cm-font="Button / 14 Regular"
                      class="cm-Margin--bottom"
                      cm-color="Neutral / Manatee">
                  Cancel
                </div>
                `,
              },
              buttons: [
                {
                  text: 'Enable Autoplay for Videos',
                  handler: () => {
                    this.settingsProvider.set('autoplayVideos', true);
                    runAutoPlay();
                  },
                },
              ],
            },
          }).promise.then(res => {
            // opted out
            if (!res) {
              this.settingsProvider.set('autoplayVideos', false);
            }
          });
        }

        function runAutoPlay() {
          const el = self.videoElement;

          try {
            if (el) {
              if (_.size(self.tools.playingVideos)) {
                self.log(
                  'scroll enter other videos: ',
                  self.tools.playingVideos
                );
                return;
              }
              const rect = el.getBoundingClientRect(),
                middle = rect.top + rect.height / 2;

              if (middle > 0 && middle < window.innerHeight) {
                el.muted = true;
                el.play();
                self.pauseUnMute = true;
                setTimeout(() => {
                  self.pauseUnMute = false;
                }, 1000);
              }
            }
          } catch (e) {}
        }
      }, 1000);
    }
  }

  scrollExit(timeInView) {
    this.logAnalyticsEvent('trackCustom', 'post-leave-v2', {
      post: _.get(this, 'post._id'),
      timeInView,
    });
    clearTimeout(this.videoAutoPlayTimeout);
    if (this.videoElement) {
      this.tools.pauseVideo(this.videoElement);
      try {
        this.videoElement.pause();
      } catch (e) {}
    }
  }

  // Lifecycle (except init) -----------

  ngOnDestroy() {
    clearTimeout(this.videoAutoPlayTimeout);
    _.each(this.subs, fn => {
      // works for event emitter and observables
      if (fn && fn.unsubscribe) {
        fn.unsubscribe();
      } else {
        fn && fn();
      }
    });
  }

  // Note sure -------------------------------

  // Random internal fns

  private presentToast(message: string) {
    this.tools.customToast(message);
  }

  private triggerPostChange(stifleEvent = false) {
    this.userEngagements = this.tools.userEngagementsOnPost(
      _.get(this.post, 'userEngagements') || []
    );

    this.postComponent &&
      this.postComponent.update &&
      this.postComponent.update();

    if (!stifleEvent) {
      this.tools.emit(`post-updated-${this.post._id}`, this, this.post);
    }
  }

  // Other admin actions ---------------------

  private urmSendApproved(post) {
    this.log('urmSendApproved | pin post');

    _.set(
      post,
      'states.urmSendApproved',
      !_.get(post, 'states.urmSendApproved', false)
    );

    this.log('urmSendApproved | post post: ', this.post);

    let urmSendApproved = _.get(post, 'states.urmSendApproved');
    this.crudApi
      .put(`/api/posts/${this.post._id}`, {
        states: { urmSendApproved },
      })
      .then(response => {
        this.log('urmSendApproved | put response: ', response);
        const message = _.get(post, 'states.urmSendApproved')
          ? 'URM Approved'
          : 'URM Post Removed';
        this.presentToast(message);
      })
      .catch(e => {
        this.log('urmSendApproved | error when pinning');
      });
  }

  private togglePin(post) {
    this.log('togglePin | pin post');

    _.set(post, 'states.isPinned', !_.get(post, 'states.isPinned', false));

    this.log('togglePin | post: ', post);

    let isPinned = _.get(post, 'states.isPinned');
    this.crudApi
      .put(`/api/posts/${post._id}`, {
        states: { isPinned },
      })
      .then(response => {
        this.log('togglePin | put response: ', response);
        const message = _.get(post, 'states.isPinned')
          ? 'Pinned post'
          : 'Unpinned post';
        this.presentToast(message);

        if (isPinned) {
          this.tools.emit(`post-pinned`, post._id);
        } else {
          this.tools.emit(`post-unpinned`, post._id);
        }
      })
      .catch(e => {
        this.log('togglePin | error when pinning');
      });
  }
  updateContextScore(increment) {
    // admin update to boost or lower score

    const newContext = _.round(
      (_.get(this.post.score, 'context') || 1) + increment,
      2
    );

    this.crudApi
      .put(`/api/posts/${this.post._id}`, {
        score: {
          context: newContext,
        },
      })
      .then(response => {
        this.log('updateContextScore | saved context multiplier: ', response);

        this.post.score.context = _.get(response.data.score, 'context') || 1;
      })
      .catch(e => {
        alert('error: ' + e);
      });
  }
}



// WEBPACK FOOTER //
// ./src/components/post/post.ts